<template>
    <div>
                <form action="#" @submit.prevent='next'>
                    <div class="input-box">
                        <label for="fullname">Hospital/Organisation name</label>
                        <input type="text" name="fullname" required v-model="form.fullname" placeholder="james eric" class="box" id="fullname" />
                    </div>
                    
                    <div class=" grid grid-cols-2">
                        <div class="input-box"><label for="state">State</label>
                        <Dropdown v-model="form.state" :options="states" optionLabel="name" optionValue="code" placeholder="Select a State" />
                        </div>
                        <div class="input-box">
                            <label for="city">City</label>
                        <Dropdown v-model="form.city" :required= true :options="cities" optionLabel="name" optionValue="code" placeholder="Select a City" />
                        </div>
                        
                    </div>
                    <div class="input-box">
                        <label for="Address">Address </label>
                        <input type="text" required v-model="form.address" placeholder="02833993" name="address" class="box" id="address" />
                    </div>
                    <div class="input-box">
                        <label for="Phone">Phone Number</label>
                        <input type="number" required v-model="form.phone" placeholder="02833993" name="Phone" class="box" id="Phone" />
                    </div>
                                     <p class="float-right block font-medium">Already have an account? <router-link to="/signin"><span class="text-red-400">Signin</span></router-link></p>

                    <div class="submit-button ">
                        <button class="box" >Continue</button>
                    </div>
                </form>
    </div>
</template>
<script>
import Dropdown from 'primevue/dropdown';
export default {
    name: 'Step1',
    data(){
        return {
            states: [
			{name: 'Lagos', code: 'Lagos'},
			{name: 'Abuja', code: 'Abuja'},
			{name: 'Ibadan', code: 'Ibadan'},
			{name: 'Ilorin', code: 'Ilorin'},
			{name: 'Osun', code: 'Osun'}
        ],
        cities: [
			{name: 'Ikeja', code: 'Ikeja'},
			{name: 'Badagry', code: 'Badagry'},
			{name: 'Mushin', code: 'Mushin'},
			{name: 'Lekki', code: 'Lekki'},
			{name: 'Shomolu', code: 'Shomolu'}
        ]
        }
    },
    components: {
        Dropdown
    },
    methods: {
        next(){
          this.$emit('nextBtn')
        }
    },
    props: ['form']
}
</script>

